import { mdiLoading } from '@mdi/js'
import Icon from '@mdi/react'
import React from 'react'

export const PageLoadingSpinner: React.FC = () => (
    <div className='flex justify-center items-center w-full h-full'>
        <Icon path={mdiLoading} size={4} spin />
    </div>
)
